module.exports = __webpack_public_path__ + "static/media/SFiOBOA_nn_sentrert_logo_stor_pos.4257ac1b.png";